import React from 'react';
import type { RefObject } from 'react';

const video: React.MutableRefObject<HTMLVideoElement | null> = React.createRef<HTMLVideoElement>();

type Item = RefObject<HTMLVideoElement | null>;

const useSingleVideo = (): [(value: Item) => void] => {
  const setVideo = (value: RefObject<HTMLVideoElement | null>) => {
    if (video.current && video.current !== value.current) {
      video.current.pause();
    }

    video.current = value.current;
  };
  return [setVideo];
};

export default useSingleVideo;
